module.exports = __webpack_public_path__ + "static/media/queen_spade.6cf465cd.png";